export default {
  subscriptionSuccessData(state,payload){
    state.subscriptionSuccessData=payload.subscriptionSuccessData
  },
  subscriptionErrorMessage(state,payload){
    state.subscriptionErrorMessage=payload.subscriptionErrorMessage
  },

  failedToDeleteSubscription(state,payload){
    state.failedToDeleteSubscription=payload.failedToDeleteSubscription
  },

  subscriptionDeleted(state,payload){
    state.subscriptionDeleted=payload.subscriptionDeleted
  },

  failedToListActiveSubscription(state,payload){
    state.failedToListActiveSubscription=payload.failedToListActiveSubscription
  },

  subscriptionList(state,payload){
    state.subscriptionList=payload.subscriptionList
    state.whitelisted=payload.whitelisted
  },

  
  failedToFetchCardList(state,payload){
    state.failedToFetchCardList=payload.failedToFetchCardList
  },
  
  cardLists(state,payload){
    state.cardLists=payload.cardLists
  },

  failedToListInvoice(state,payload){
    state.failedToListInvoice=payload.failedToListInvoice
  },

  invoiceList(state,payload){
    state.invoiceList=payload.invoiceList
  },


  failedToDelete(state,payload){
    state.failedToDelete=payload.failedToDelete
  },


  listSubscriptionPlans(state, payload) {
    state.listSubscriptionPlans = payload.listSubscriptionPlans;
  },
  failedToFetchPlansInfo(state, payload) {
    state.failedToFetchPlansInfo = payload.failedToFetchPlansInfo;
  },
  failedToFetchProductListMessage(state, payload) {
    state.failedToFetchProductListMessage =
      payload.failedToFetchProductListMessage;
  },
  listUserBasedPlan(state, payload) {
    state.userBasedPlanInfo = payload.userBasedPlanInfo;
  },
};
